import React, { Component } from 'react';
import { Table } from 'antd';
import TableText from "../../TableText";

class index extends Component {
    onChange = (name, value, i) => {
        let data = this.props.data;
        data[i][name] = value;
        this.props.onChange('dataInput', data, true);
    }
    render() {
        const data = this.props.data;
        const columns = [{
            title: 'Departments',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            render: (text, record, index) => {
                const props = { text, index, type: 'text', name: "name", onChange: this.onChange, totalIndex: [] };
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: '-',
            dataIndex: 'value',
            key: 'value',
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'input', name: "value", onChange: this.onChange, totalIndex: [],
                };
                return (
                    <TableText data={props} />
                )
            }
        }];
        return (
            <Table
                columns={columns}
                dataSource={data}
                size="middle"
                bordered
                pagination={false}
                showHeader={false}
                loading={this.props.loading}
                className="content"
                rowKey={(record, index) => index}
            />
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-10/2-4.js